import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import isNil from 'lodash/isNil'

import { NumberInput } from '../../Controls/NumberInput'
import { formAmountSelector, formLotsSelector, currentSymbolLotRoundingSelector } from '../../../../store/selectors'
import { numberFormat } from '../../../../utils'
import { NumberInputLabel } from '../../Controls/NumberInputLabel'

const AmountInput: FC<{ contractType: string }> = ({ contractType }) => {
  const { t } = useTranslation()
  const { value, fieldInformation } = useSelector(formAmountSelector)
  const lotRounding = useSelector(currentSymbolLotRoundingSelector)
  const lots = useSelector(formLotsSelector)

  if (isNil(lotRounding)) {
    return null
  }

  return (
    <>
      <NumberInputLabel name="amount" unit={contractType} />
      <NumberInput
        name={'amount'}
        placeholder={t(`amount`, 'Amount')}
        value={numberFormat(value, {
          maximumFractionDigits: lotRounding,
        })}
        fieldInformation={fieldInformation}
        lots={lots}
      />
    </>
  )
}

export default AmountInput
